import { DataStatus } from 'src/core/engine';

import { CartState } from '../cart.reducer';

export const status_selector = (x: { cart: CartState }) => x.cart.status;
export const items_qty_selector = (x: { cart: CartState }) => x.cart.items?.length;
export const items_selector = (x: { cart: CartState }) => x.cart.items;
export const is_pending_selector = (x: { cart: CartState }) =>
    x.cart.status === DataStatus.Pending || x.cart.status === DataStatus.Idle;
